import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Defaultcase } from "./defaultcase.model";

@Injectable({
  providedIn: 'root'
})
export class DefaultcaseService {

  constructor(private httpClient: HttpClient) { }

  public selectedDefaultCase: Defaultcase;

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDDefaultChange(defaultcase:Defaultcase){

    defaultcase.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    defaultcase.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    defaultcase.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    defaultcase.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = defaultcase;
    
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/DefaultCase/IUD', body, { headers: headers });
    }

  FetchDefaultCaseById(defaultcase) {

    defaultcase.Id = + defaultcase.Id;
    defaultcase.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    defaultcase.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    defaultcase.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    defaultcase.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = defaultcase;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/DefaultCase/Fetch', body, { headers: headers });
  }

  FetchDefaultCaseList(){
    this.selectedDefaultCase = new Defaultcase();
    this.selectedDefaultCase.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedDefaultCase.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedDefaultCase.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedDefaultCase.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.selectedDefaultCase.ToDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body =  this.selectedDefaultCase;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/DefaultCase/FetchList', body, { headers: headers });
  }

}
